import { useState, useEffect } from 'react';
import { titlesService, Title, CreateTitleData, UpdateTitleData } from '../services/firebaseFunctions';

export const useTitles = () => {
  const [titles, setTitles] = useState<Title[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Carregar títulos
  const loadTitles = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await titlesService.getAll();
      setTitles(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar títulos');
    } finally {
      setLoading(false);
    }
  };

  // Criar título
  const createTitle = async (data: CreateTitleData) => {
    try {
      const result = await titlesService.create(data);
      if (result.success && result.data) {
        setTitles((prev) => [...prev, result.data!]);
        return { success: true, message: 'Título criado com sucesso!' };
      } else {
        throw new Error(result.error);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao criar título';
      return { success: false, message: errorMessage };
    }
  };

  // Atualizar título
  const updateTitle = async (id: string, data: UpdateTitleData) => {
    try {
      const result = await titlesService.update(id, data);
      if (result.success) {
        setTitles((prev) => prev.map((title) => (title.id === id ? { ...title, ...data } : title)));
        return { success: true, message: 'Título atualizado com sucesso!' };
      } else {
        throw new Error(result.error);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao atualizar título';
      return { success: false, message: errorMessage };
    }
  };

  // Deletar título
  const deleteTitle = async (id: string) => {
    try {
      const result = await titlesService.delete(id);
      if (result.success) {
        setTitles((prev) => prev.filter((title) => title.id !== id));
        return { success: true, message: 'Título excluído com sucesso!' };
      } else {
        throw new Error(result.error);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao excluir título';
      return { success: false, message: errorMessage };
    }
  };

  // Carregar títulos na inicialização
  useEffect(() => {
    loadTitles();
  }, []);

  return {
    titles,
    loading,
    error,
    createTitle,
    updateTitle,
    deleteTitle,
    loadTitles,
  };
};
